import { User } from '@/shared/types/User';

export const getCreditsState = (credits: User['credits']) => {
  if (!credits) {
    return {
      availableFreeVideos: 0,
      availableMinutes: 0,
      hasFreeLipSyncMinutes: false,
      hasFreeVideos: false,
      hasMinutes: false,
    };
  }

  const { lipsync_free_minutes, minutes, video } = credits;

  const totalFreeLipSyncMinutes = lipsync_free_minutes?.total ?? 0;
  const usedFreeLipSyncMinutes = lipsync_free_minutes?.used ?? 0;
  const totalMinutes = minutes?.total ?? 0;
  const usedMinutes = minutes?.used ?? 0;
  const totalFreeVideos = video?.total ?? 0;
  const usedFreeVideos = video?.used ?? 0;

  const hasFreeLipSyncMinutes = totalFreeLipSyncMinutes - usedFreeLipSyncMinutes > 0;
  const hasFreeVideos = totalFreeVideos - usedFreeVideos > 0;
  const hasMinutes = totalMinutes - usedMinutes > 0;
  const availableMinutes = totalMinutes - usedMinutes;
  const availableFreeVideos = totalFreeVideos - usedFreeVideos;

  return {
    availableFreeVideos,
    availableMinutes,
    hasFreeLipSyncMinutes,
    hasFreeVideos,
    hasMinutes,
  };
};
